import $ from 'jquery';
import { fadeSlideIn, fadeSlideOut } from './animate';
export const getInputValue = ($input) => {
    if (isCheckbox($input)) {
        return $input.is(':checked');
    }
    if (isRadio($input)) {
        return getAssociatedInputs($input).filter(':checked').val();
    }
    if (!$input.val() && isDropdown($input)) {
        return $input.dropdown('get value');
    }
    return $input.val();
};
export const getAssociatedInputs = ($input) => {
    return $(`input[name="${$input.attr('name')}"]`);
};
export const isCheckbox = ($input) => {
    return $input.is('[type="checkbox"]');
};
export const isRadio = ($input) => {
    return $input.is('[type="radio"]');
};
export const isDropdown = ($input) => {
    return $input.hasClass('dropdown');
};
export const clearInputValue = ($input) => {
    if (isCheckbox($input) || isRadio($input)) {
        $input.prop('checked', false);
    }
    else if (isDropdown($input)) {
        $input.dropdown('clear');
    }
    else {
        $input.val('');
    }
    $input.trigger('change');
};
export const disableElement = ($element, disable, disabledValue = '', clearDisabled = false, hideDisabled = false, disableDirectElement = false, triggerChangeOnEnable = false, duration = 300, readonly = false) => {
    const $parent = $element.closest('.field:not(.js__toggle-element)').length
        ? $element.closest('.field:not(.js__toggle-element)')
        : $element.closest('.js__toggle-element');
    const isReadOnly = readonly || $element.data('readonly');
    if (isReadOnly) {
        $parent.find('input, select, textarea').not('.search').prop('readonly', disable);
        $element.find('.dropdown').toggleClass('readonly', disable);
        $element.find('.dropdown.icon').toggleClass('disabled', disable);
        $element.find('.search').toggleClass('disabled', disable).prop('disabled', disable);
        $element.parent().closest('.dropdown').toggleClass('readonly', disable);
    }
    else {
        $parent.find('input, select, textarea').prop('disabled', disable);
        $element.find('.dropdown').toggleClass('disabled', disable);
        $element.parent().closest('.dropdown').toggleClass('disabled', disable);
    }
    if (triggerChangeOnEnable && !disable) {
        $parent.find('input, select, textarea').trigger('change');
        $element.find('.dropdown').trigger('change');
        $element.parent().closest('.dropdown').trigger('change');
    }
    if (disableDirectElement) {
        if (disable && hideDisabled) {
            fadeSlideOut($element, duration);
        }
        else {
            fadeSlideIn($element, duration);
        }
        $element.toggleClass('disabled disable-all-fields', disable);
    }
    else {
        if (disable && hideDisabled) {
            fadeSlideOut($parent, duration);
        }
        else {
            fadeSlideIn($parent, duration);
        }
    }
    const $disableOnTargetValueElement = $element.find('.js__disable-on-target-value');
    if (!disable && $disableOnTargetValueElement.length) {
        $($disableOnTargetValueElement.data('target')).trigger('change');
    }
    if (disable && disabledValue) {
        $element.find('.dropdown').dropdown('set selected', disabledValue).trigger('change');
        $element.find('.dropdown').val(disabledValue).trigger('change');
        // @ts-ignore
        $element.parent().closest('.dropdown').dropdown('set selected', disabledValue).trigger('change');
    }
    if (disable && clearDisabled) {
        const $dropdownInput = $parent.find('.dropdown:not(.icon)');
        const $dropdownSearchInput = $parent.find('input.search');
        clearInputValue($dropdownInput.length ? $dropdownInput : $element);
        clearInputValue($dropdownSearchInput);
    }
};
